/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Already_MemberInputs */

const en_adm_err_already_member = /** @type {(inputs: Adm_Err_Already_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person is already a member.`)
};

const de_adm_err_already_member = /** @type {(inputs: Adm_Err_Already_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Person ist bereits Mitglied.`)
};

/**
* | output |
* | --- |
* | "This person is already a member." |
*
* @param {Adm_Err_Already_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_already_member = /** @type {((inputs?: Adm_Err_Already_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Already_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_already_member(inputs)
	return en_adm_err_already_member(inputs)
});